import { z } from "zod";
const _appConfigSchema = z.object({
  /** whether to show onboarding first */
  onBoarding: z.boolean().optional().default(true),
  /** whether to show change workspace guide modal */
  dismissWorkspaceGuideModal: z.boolean().optional().default(false)
});
const defaultAppConfig = _appConfigSchema.parse({});
const _storage = {};
let _inMemoryId = 0;
class Storage {
  constructor(options) {
    this._id = _inMemoryId++;
    this._options = {
      get: () => _storage[this._id],
      set: (data) => _storage[this._id] = data,
      ...options
    };
    this._cfg = this.get() ?? options.config;
  }
  /**
   * update entire config
   * @param data
   */
  set(data) {
    try {
      this._options.set(data);
    } catch (err) {
      console.error("failed to save config", err);
    }
    this._cfg = data;
  }
  /**
   * get config, if key is provided, return the value of the key
   * @param key
   * @returns
   */
  get(key) {
    if (!key) {
      try {
        const cfg = this._options.get();
        if (!cfg) {
          this.set(this._options.config);
          return this._options.config;
        }
        return cfg;
      } catch (err) {
        return this._cfg;
      }
    } else {
      const fullConfig = this.get();
      return fullConfig[key];
    }
  }
  /**
   * update a key in config
   * @param key
   * @param value
   */
  patch(key, value) {
    this.set({ ...this.get(), [key]: value });
  }
  get value() {
    return this.get();
  }
}
class AppConfigStorage extends Storage {
}
export {
  AppConfigStorage,
  defaultAppConfig
};
